import { render, staticRenderFns } from "./main.vue?vue&type=template&id=13e3fc06"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"
import style0 from "./main.vue?vue&type=style&index=0&id=13e3fc06&prod&lang=less"
import style1 from "./main.vue?vue&type=style&index=1&id=13e3fc06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports